import React, { createContext, useContext, useEffect, useState } from 'react';
import en from '../multilang/en';
import hi from '../multilang/hi';
import mr from '../multilang/mr'

const translations = { en, hi, mr};
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('en');

  // Load language from localStorage on first render
  useEffect(() => {
    const storedLang = localStorage.getItem('app_language');
    if (storedLang && translations[storedLang]) {
      setLanguageState(storedLang);
    }
  }, []);

  // Save language to localStorage
  const setLanguage = (lang) => {
    if (translations[lang]) {
      localStorage.setItem('app_language', lang);
      setLanguageState(lang);
    }
  };

  const t = (key, vars = {}) => {
    let text = translations[language][key] || key;
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{{${k}}}`, v);
    });
    return text;
  };

  return (
    <LanguageContext.Provider value={{ t, language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
